// Hero.jsx
import React from "react";
import { motion } from "framer-motion";
import heroVideo from "../Videos/hero-vdo.mp4";

const Hero = () => {

  // Container (stagger everything like tile placement)
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  // Upward solid reveal
  const fadeUpStrong = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.8, 0.25, 1], // custom smooth industrial easing
      },
    },
  };

  // Overlay fade (depth effect)
  const overlayAnim = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1 } },
  };

  return (
    <section className="hero-section">

      {/* VIDEO BACKGROUND */}
      <video
        className="hero-video"
        src={heroVideo}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* GRADIENT OVERLAY */}
      <motion.div
        className="hero-overlay"
        variants={overlayAnim}
        initial="hidden"
        animate="visible"
      />

      {/* CONTENT */}
      <motion.div
        className="container hero-content"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {/* HEADING */}
        <motion.h1 variants={fadeUpStrong}>
          Vigoflex Adhesive Engineered for Strength. Built to Last.
        </motion.h1>

        {/* TEXT */}
        <motion.p variants={fadeUpStrong}>
          High-performance VigoFlex tile adhesives engineered for durable bonding across every surface and condition.
        </motion.p>

        {/* BUTTONS */}
        <motion.div className="hero-buttons" variants={fadeUpStrong}>
          <motion.a
          href="#products"
            className="btn btn-primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.92 }} // strong press feel
            transition={{ type: "spring", stiffness: 300 }}
          >
            Choose Your Product
          </motion.a>

          <motion.a
          href="/calculator"
            className="btn btn-outline"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.92 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            Calculate Requirement
          </motion.a>
        </motion.div>
      </motion.div>

    </section>
  );
};

export default Hero;